import { isOpx } from 'owa-opx';
import InsightsDataFetchSource from '../store/schema/InsightsDataFetchSource';

export const MAX_CONTENT_TO_SHOW = 10;
export const WIDTH_OF_EACH_TILE = 242;
export const RIGHT_PADDING_OF_EACH_TILE = 8;

const MAX_CONTENT_TO_SHOW_INITIALLY_GROUP = 3;
const MAX_CONTENT_TO_SHOW_INITIALLY_SINGLE = 1;
export const MAX_CONTENT_TO_SHOW_INITIALLY_OPX = 3;

export function getMaxInsightsToShowOnInitialRender(
    insightsEntrySource: InsightsDataFetchSource
): number {
    if (isOpx()) {
        return MAX_CONTENT_TO_SHOW_INITIALLY_OPX;
    }

    let insightsToShow = 0;
    switch (insightsEntrySource) {
        case InsightsDataFetchSource.ItemPeek:
        case InsightsDataFetchSource.AgendaView:
        case InsightsDataFetchSource.UpNext:
            insightsToShow = MAX_CONTENT_TO_SHOW_INITIALLY_SINGLE;
            break;
        case InsightsDataFetchSource.ReadingPane:
        case InsightsDataFetchSource.CalendarCard:
        case InsightsDataFetchSource.TimePanelEventDetails:
        case InsightsDataFetchSource.TabbedDetailsForm:
        default:
            insightsToShow = MAX_CONTENT_TO_SHOW_INITIALLY_GROUP;
            break;
    }
    return insightsToShow;
}
